import { api } from './api';

// GET SOS events (cursor-paginated; params: limit, cursor, status, type)
export const getSosEvents = (params?: any) => api.get('/admin/safety/sos-events', { params });

// RESOLVE an SOS event — outcome (safe | false_alarm | police | medical | other) and a closing note are required
export const resolveSosEvent = (id: number, note: string, outcome: string) =>
    api.patch(`/admin/safety/sos-event/${id}/resolve`, { note, outcome });

// ACKNOWLEDGE: a person has seen it (stops the escalation ladder; first response on its P0 ticket)
export const acknowledgeSosEvent = (id: number) => api.post(`/admin/safety/sos-event/${id}/ack`, {});

// Mint a FRESH follow link for the event's ride (admin view outlives public expiry)
export const getSosFollowLink = (id: number) =>
    api.get<{ token: string; url: string }>(`/admin/safety/sos-event/${id}/follow-link`);
